import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    static targets = ['button', 'source','link']
    static values = {
        successDuration: {
            type: Number, default: 2000
        }, reportName: {
            type: String, default: "Report"
        }, autoCopy: {
            type: Boolean, default: false
        }
    }

    connect() {
        if (!this.hasButtonTarget) return
        this.originalContent = this.buttonTarget.innerHTML
        if (this.autoCopyValue) {
            this.autoCopy();
        }
    }

    autoCopy() {
        var text = this.buttonTarget.dataset.value
        return this.copyText(text)
            .then(() => {
                this.autoCopied()
            })
            .catch(err => {
                console.error('Failed to copy table: ', err);
            });

    }

    autoCopied() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
        let originalHtml = this.linkTarget.innerHTML
        this.linkTarget.textContent = "Copied"
        this.timeout = setTimeout(() => {
            this.linkTarget.innerHTML = originalHtml
        }, this.successDurationValue)

    }

    // Function to override on copy.
    copy(event) {
        event.preventDefault()
        var text = ''
        if (this.sourceTarget.nodeName === 'TABLE') {
            text = this.sourceTarget.outerHTML.replace(/href=/g, '')
        } else {
            text = this.sourceTarget.innerHTML || this.sourceTarget.value
        }

        return this.copyText(text)
            .then(() => {
                this.copied()
            })
            .catch(err => {
                console.error('Failed to copy table: ', err);
            });
    }

    // Function to override when to input is copied.
    copied() {
        if (!this.hasButtonTarget) return

        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        this.buttonTarget.innerHTML = "<span class='text-green-500'><i data-lucide=\"check\" class=\"w-4 h-4 inline\"></i> </span>"
        if (window.lucide) window.lucide.createIcons()

        this.timeout = setTimeout(() => {
            this.buttonTarget.innerHTML = this.originalContent
        }, this.successDurationValue)
    }

    copypath(event) {
        var url = event.target.dataset['path']
        this.buttonTarget.innerHTML = "<span class='text-green-500'><i data-lucide=\"loader-circle\" class=\"w-4 h-4 inline animate-spin\"></i> </span>"
        if (window.lucide) window.lucide.createIcons()
        fetch(url, {
            method: 'GET', headers: {
                "Content-Type": "application/json", 'Accept': 'application/json',
            }
        }).then((response) => response.json()).then(result => {
            var data = result.data
            return this.copyText(data)
                .then(() => {
                    this.copied()
                })
                .catch(err => {
                    console.error('Failed to copy table: ', err);
                });
        })
    }

    copyText(text) {
        return this.copyWithSelection(text).catch(() => {
            if (navigator.clipboard?.writeText) {
                return navigator.clipboard.writeText(text)
            }

            throw new Error('Browser denied clipboard access')
        })
    }

    copyWithSelection(text) {
        return new Promise((resolve, reject) => {
            const activeElement = document.activeElement
            const selectableSource = ['INPUT', 'TEXTAREA'].includes(this.sourceTarget?.nodeName)
            const source = selectableSource ? this.sourceTarget : document.createElement('textarea')

            if (!selectableSource) {
                source.value = text
                source.setAttribute('readonly', '')
                source.style.position = 'fixed'
                source.style.opacity = '0'
                document.body.appendChild(source)
            }

            source.select()

            let copied = false
            try {
                copied = document.execCommand('copy')
            } finally {
                if (!selectableSource) source.remove()
                activeElement?.focus()
            }

            if (copied) {
                resolve()
            } else {
                reject(new Error('Browser denied clipboard access'))
            }
        })
    }
}
